// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 49) return "static/chunks/49-00490ab9d22ef1f5.js";
	if (chunkId === 149) return "static/chunks/149-c243ec6a271d83ca.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"264":"5cad4584a619a434","500":"2b3c56a869cad2fb","519":"74b1e386db84bf0c","804":"eb5c738d35012526","806":"ce64fd636483db1a","874":"0c364546dc4af46d","981":"d239c570346fcce4"}[chunkId] + ".js";
};